var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar'),_c('v-main',[_c('router-view'),_c('snackbar-widget')],1),(_vm.gtagId)?_c('div',[_c('cookie-consent')],1):_vm._e(),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }